// extracted by mini-css-extract-plugin
export var box = "_5u-0";
export var check = "_5u-1";
export var checkboxButton = "_5u-6";
export var checkboxGroup = "_5u-5";
export var disabled = "_5u-7";
export var ghost = "_5u-9";
export var input = "_5u-2";
export var label = "_5u-4";
export var normal = "_5u-8";
export var uncheck = "_5u-3";